// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportPartHeaderActions.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!(function() {
  var compose = require('recompose').compose;
  var withHandlers = require('recompose').withHandlers;
  var withState = require('recompose').withState;
  var LayoutUtils = require('share/utils/Izenda.LayoutUtils');
  var registry = require('./ReportPartType/Izenda.ReportPartTypeRegistry');
  const { curry, flow, invokeArgs, find, get } = require('lodash/fp');
  var headerActions = compose(
    withState('isShowHeaderConfig', 'setShowHeaderConfig', false),
    withHandlers({
      onMouseEnter: curry(onMouseEnter),
      onMouseLeave: curry(onMouseLeave),
      selectReportPart: curry(selectReportPart),
      hasPermission: curry(hasPermission)
    })
  );

  /**
   * show Header Config
   */
  function onMouseEnter(props, _) {
    props.setShowHeaderConfig(true);
  }

  /**
   * hide Header Config
   */
  function onMouseLeave(props, _) {
    props.setShowHeaderConfig(false);
  }

  function selectReportPart(props, e) {
    // each button in header will be handle to show/hide props editor themself
    if (invokeArgs('getAttribute', ['data-btnName'], e.target.parentElement) === 'btnAction') {
      return;
    }

    if (invokeArgs('getAttribute', ['data-btnName'], e.target) === 'btnAction' || e.target.tagName === 'INPUT') {
      return;
    }

    if (e.button === 0) {
      props.onClick && props.onClick();
    }
    LayoutUtils.togglePropertiesEditor(true);
  }

  /**
   * Check user has permission on this type of report part
   * Remove : Copy, Delete, Switch button if don't have permission
   */
  function hasPermission(props, e) {
    var reportPartType = props.reportPart.type;

    var reportPartPrivileges = flow(
      find({ value: reportPartType }),
      get('permissions')
    )(registry.REPORT_PART_TYPES);

    return !reportPartPrivileges || props.authorization.checkPrivileges(reportPartPrivileges);
  }

  module.exports = headerActions;
})();



// WEBPACK FOOTER //
// ./ui/modules/ReportDesigner/Fields/ReportBody/Izenda.ReportPartHeaderActions.js